import api from './authService';

export const adminContactMessagesService = {
  getList: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await api.get(`/admin/contact-messages${queryString ? `?${queryString}` : ''}`);
    return response.data;
  },
  getOne: async (id) => {
    const response = await api.get(`/admin/contact-messages/${id}`);
    return response.data;
  },
  update: async (id, data) => {
    const response = await api.put(`/admin/contact-messages/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`/admin/contact-messages/${id}`);
    return response.data;
  },
  reply: async (id, reply) => {
    const response = await api.post(`/admin/contact-messages/${id}/reply`, { reply });
    return response.data;
  },
};
